export default "__VITE_ASSET__BNyW5NlV__"